import { isEmpty, get, isUndefined } from 'lodash-es'

const required = (value) => {
  return value ? undefined : 'This field is required'
}
const requiredWithCustomError = (error) => (value) => {
  return value ? undefined : error
}

const emailRegEx =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const validateEmail = (email) =>
  email && !emailRegEx.test(email.toLowerCase())
    ? 'Invalid email address'
    : undefined

const number = (value) => {
  return value && Number.isNaN(Number(value)) ? 'Must be a number' : undefined
}

const absoluteUrl = (value) => {
  if (isEmpty(value)) {
    return undefined
  }

  const isAbsoluteUrl = /(http(s)?)/gi.test(value)
  return isAbsoluteUrl ? undefined : 'The URL should start with http or https'
}

const retypePassword = (_, allValues) => {
  const password = get(allValues, 'password')
  const rePassword = get(allValues, 're-password')

  if (isUndefined(password)) {
    return undefined
  }

  return password === rePassword ? undefined : "The password doesn't match"
}

const domainRegEx =
  /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/

const validateDomain = (domain) =>
  domain && !domainRegEx.test(domain.toLowerCase())
    ? 'Invalid domain'
    : undefined

export default {
  required,
  requiredWithCustomError,
  validateEmail,
  validateDomain,
  number,
  absoluteUrl,
  retypePassword,
}
